export const uiPricingCalculator = {
    name: 'UI Pricing Calculator',
    description: '',
    displayField: 'title',
    fields: {
        title: {
            name: 'Title',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        userCountLabel: {
            name: 'User count label',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        priceLabel: {
            name: 'Price label',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        annualTotalText: {
            name: 'Annual total text',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        averagePricePerUserText: {
            name: 'Average price per user text',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        generalError: {
            name: 'General error',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        minUsersError: {
            name: 'Min users error',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        maxUsersError: {
            name: 'Max users error',
            type: 'Symbol',
            required: true,
            localized: true,
            disabled: false,
            omitted: false,
            validations: []
        },
        tiers: {
            name: 'Tiers',
            type: 'Link',
            linkType: 'Entry',
            required: true,
            localized: false,
            disabled: false,
            omitted: false,
            validations: [{ linkContentType: ['uiPricingTier'] }]
        }
    }
};
//# sourceMappingURL=uiPricingCalculator.js.map